module.exports = __webpack_public_path__ + "img/grid-sample3.b8ae6235.jpg";